
import { userActions } from "./user";
import { fileActions } from "./file";
import { stationActions } from "./station";
import { themeActions } from "./theme";

import UserReducer from "./user";
import FileReducer from "./file";
import StationReducer from "./station";
import ThemeReducer from "./theme";

const actions = {
    user: userActions,
    files: fileActions,
    stations: stationActions,
    theme: themeActions
}

const rootReducer = {
    user: UserReducer,
    file: FileReducer,
    stations: StationReducer,
    theme: ThemeReducer
}

export { rootReducer, actions };
